// Models
import { IntakeStepModel } from 'app/_models/intakestep.model';
import { IntakeDataModel } from 'app/_models/intakedata.model';
import { intakeTimeValueModel } from './intakeTimeValue.model';

export class IntakeModel {
    draftDossierNumber : string;
    steps: IntakeStepModel[] = intakeStepsData;
    intake: IntakeDataModel = new IntakeDataModel();
    intakeDuration: intakeTimeValueModel = new intakeTimeValueModel();
    active: IntakeStepModel = intakeStepsData.reduce((p, c) => (p.step < c.step && p.enabled) ? p : c);
    editMode: boolean = true;
    creationDate : string;
}

export const intakeStepsData: IntakeStepModel[] = [
    {
        step: 0,
        label: "Policy",
        isActive: true,
        enabled: true,
        url: "policy",
        icon: "faClipboardCheck",
        isMendatory: true
    },
    {
        step: 1,
        label: "Insuree",
        isActive: false,
        enabled: true,
        url: "insuree",
        icon: "UserInjured",
        isMendatory: true
    },
    {
        step: 2,
        label: "Case",
        isActive: false,
        enabled: true,
        url: "case",
        icon: "faHospital",
        isMendatory: true
    },
    {
        step: 3,
        label: "ADL",
        isActive: false,
        enabled: false,
        url: "adl",
        icon: "faNotesMedical",
        isMendatory: true
    },
    {
        step: 4,
        label: "Rehospitalisation",
        isActive: false,
        enabled: false,
        url: "rehospitalisation",
        icon: "faHospitalUser",
        isMendatory: true
    },
    {
        step: 5,
        label: "Location",
        isActive: false,
        enabled: true,
        url: "location",
        icon: "faMapMarkerAlt",
        isMendatory: true
    },
    {
        step: 6,
        label: "Travel",
        isActive: false,
        enabled: false,
        url: "travel",
        icon: "faPlaneDeparture",
        isMendatory: true
    },
    {
        step: 7,
        label: "Party",
        isActive: false,
        enabled: false,
        url: "party",
        icon: "faUsers",
        isMendatory: true
    },
    {
        step: 8,
        label: "Help Plan",
        isActive: false,
        enabled: true,
        url: "help-plan-list",
        icon: "faList",
        isMendatory: true
    },
    {
        step: 9,
        label: "Notes",
        isActive: false,
        enabled: false,
        url: "notes",
        icon: "faClipboardCheck",
        isMendatory: true
    },
    {
        step: 10,
        label: "Actions",
        isActive: false,
        enabled: false,
        url: "actions",
        icon: "faClipboardCheck",
        isMendatory: true
    },
    {
        step: 16,
        label: "Service Fees",
        isActive: false,
        enabled: false,
        url: "dossier-work-activity",
        icon: "faClipboardCheck",
        isMendatory: true
    },
    {
        step: 11,
        label: "DBC",
        isActive: false,
        enabled: false,
        url: "dbc",
        icon: "faStethoscope",
        isMendatory: true
    },
    {
        step: 13,
        label: "Attachments",
        isActive: false,
        enabled: false,
        url: "attachments",
        icon: "faFolderOpen",
        isMendatory: true
    },
    {
        step: 12,
        label: "Correspondance",
        isActive: false,
        enabled: false,
        url: "correspondance",
        icon: "faClipboardCheck",
        isMendatory: true
    },   
    {
        step: 14,
        label: "Cost Control",
        isActive: false,
        enabled: false,
        url: "cost-control",
        icon: "faFileInvoiceDollar",
        isMendatory: true
    },   
    {
        step: 15,
        label: "Summary",
        isActive: true,
        enabled: true,
        url: "summary",
        icon: "faFolderOpen",
        isMendatory: true
    },    
];